// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v954vgCYzPS0W7HemSd2 {
  .YtMKgM5lvlui2yTGTuf3 {
    color: white;
  }
  .MFluqu3g4FQtyHRZnP3a {
    margin-top: 1rem;
  }
  .cJlhCECOQC5JSPbYfUwr .vQ1jqPJK88COTpxyck5w:hover .YtMKgM5lvlui2yTGTuf3 {
    color: black !important;
  }
  .ljBJ7JPyzsXKa8nS3mlw .vQ1jqPJK88COTpxyck5w {
    background-color: #eee !important;
    color: #000 !important;
  }
  .ljBJ7JPyzsXKa8nS3mlw .vQ1jqPJK88COTpxyck5w .YtMKgM5lvlui2yTGTuf3 {
    color: black !important;
  }
}

.uSZPEDkHAyZBETMiLTV2 {
  .oZJYFSIgeqYpCMqK1zc4 {
    color: white;
  }
  .WHlx0W5LXABmlO0D64Rs {
    color: white !important;
  }
}

.QCtivsOkscA7Bsvaej8M:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/layout/client-layout/layout.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAA;EACF;EAEA;IACE,gBAAA;EAAF;EAGA;IACE,uBAAA;EADF;EAIA;IACE,iCAAA;IACA,sBAAA;EAFF;EAKA;IACE,uBAAA;EAHF;AACF;;AAMA;EACE;IACE,YAAA;EAHF;EAMA;IACE,uBAAA;EAJF;AACF;;AAOA;EACE,eAAA;AAJF","sourceRoot":""}]);
// Exports
var _1 = `v954vgCYzPS0W7HemSd2`;
export { _1 as "client-menu" };
var _2 = `YtMKgM5lvlui2yTGTuf3`;
export { _2 as "p-menuitem-text" };
var _3 = `MFluqu3g4FQtyHRZnP3a`;
export { _3 as "p-menubar-root-list" };
var _4 = `cJlhCECOQC5JSPbYfUwr`;
export { _4 as "p-menubar" };
var _5 = `vQ1jqPJK88COTpxyck5w`;
export { _5 as "p-menuitem-link" };
var _6 = `ljBJ7JPyzsXKa8nS3mlw`;
export { _6 as "active-menu-item" };
var _7 = `uSZPEDkHAyZBETMiLTV2`;
export { _7 as "client-datatable" };
var _8 = `oZJYFSIgeqYpCMqK1zc4`;
export { _8 as "p-sortable-column-icon" };
var _9 = `WHlx0W5LXABmlO0D64Rs`;
export { _9 as "p-column-title" };
export var logo = `QCtivsOkscA7Bsvaej8M`;
export default ___CSS_LOADER_EXPORT___;
